import { makeAutoObservable, runInAction } from "mobx";
import i18n from "i18n";
import {
  getEtbAll,
  checkADSMPatient,
  saveADSMPatient
} from "../Services/PatientService";
import {
  createEtbTreatmentBookDetailDto,
  editEtbTreatmentBookDetailDto,
  getEtbTreatmentBookDetailDto,
  checkValidatePeriod
} from "../Services/EtbTreatmentBookService";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import LocalConstants from "app/LocalConstants";
import {
  deleteEpisodeOfCare,
  createdCheckPeriod,
} from "../Services/EpisodeOfCareService";
import localStorageService from "app/services/localStorageService";

export default class EtbTreatmentBookStores {
  selectedTreatmentBook = null;
  selectedTreatmentBookDetail = null;
  loadingInitial = false;
  patientId = "";
  editable = false;
  defaultEpisodeOfCare= {
    id: "",
    registerNo: "",
    patientType: null,
    manAdministrativeUnit: null,
    manOrg: null,
    treatmentAdministrativeUnit: null,
    treatmentUnit: null,
    registerDate: null,
    treatmentStartDate: null,
    activeTbHiv: [
      {
        id : "",
        typeTreatment: 1,
      },
      {
        id : "",
        typeTreatment: 2,
      },
    ]
  }
  openPrintPreview=false;

  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  handleSelectEtb = (data) => {
    this.selectedPatient = data?.patientDto;
    this.defaulHistoryEncounterList = this.historyEncounterList = data?.historyEncounterList || [];
    this.countEncounter = data?.countEncounter || 0;
    this.episodeOfCareList = data?.episodeOfCareList || [];

    this.handleSelectEncounter(data?.currentEncounter)
    this.countEpisodeOfCare = data?.countEpisodeOfCare || 0;
  };

  getEtbAllTreatmentBook = async (patientId, id) => {
    if (patientId != null) {
      const obj = {
        patientId: patientId,
        typeBook: LocalConstants.TypeBook?.[1]?.value,
        currentPeriodId: id
      }
      try {
        let res = await getEtbAll(obj);
        this.handleSelectItem(res.data);
        return res.data;
      } catch (error) {
        console.log(error);
        toast.warning(i18n.t("toast.error"));
      }
    } else {
      this.handleSelectItem(null);
    }
  };

  handleEditEtbTreatmentBookDetail = (id) => {
    this.getEtbTreatmentBookDetailDto(id).then(() => {
    });
  };

  getEtbTreatmentBookDetailDto = async (id) => {
    if (id != null) {
      try {
        let data = await getEtbTreatmentBookDetailDto(id);
        this.handleSelectItemDetail(data.data);
      } catch (error) {
        console.log(error);
        toast.warning(i18n.t("toast.error"));
      }
    } else {
      this.handleSelectItemDetail(null);
    }
  };

  handleSelectItem = (etbDto) => {
    this.selectedTreatmentBook = etbDto?.treatmentBook;
    this.selectedTreatmentBookDetail = etbDto?.treatmentBook?.detail;
  };
  handleSelectItemDetail = (item) => {
    this.selectedTreatmentBookDetail = item;
  };

  checkValidatePeriod = async (item) => {
    try {
      let resCheckValidatePeriod = await checkValidatePeriod(item);
        return resCheckValidatePeriod;
    }
    catch (e){
      console.error(e);
    }
  }

  createEtbTreatmentBookDetailDto = async (item) => {
    try {
      // let resCheckValidatePeriod = await checkValidatePeriod(item);
      // // console.log(resCheckValidatePeriod);
      // if (resCheckValidatePeriod?.data?.code === "-1") {
      //   return resCheckValidatePeriod;
      // } else {
        const res = await createEtbTreatmentBookDetailDto(item);
        setTimeout(() => {
          localStorageService.removeItem(LocalConstants.LOCAL_STORAGE_CREATE_PERIOD_KEY)
        }, 1000)
        return res;
      // }
    } catch (error) {
      console.log(error);
      setTimeout(() => {
        localStorageService.setItem(
          LocalConstants.LOCAL_STORAGE_CREATE_PERIOD_KEY,
          JSON.stringify({
            ...item,
            userId: localStorageService.getLoginUser()?.id,
            patientId: this.patientId
          })
        )
      }, 1000)
      toast.warning(i18n.t("toast.add_fail"));
    }
  };

  editEtbTreatmentBookDetailDto = async (item) => {
    try {
        const res = await editEtbTreatmentBookDetailDto(item, item.id);
        return res;
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.update_fail"));
    }
  };

  setPatientId = (id) => {
    this.patientId = id;
  }

  setEditable = (value) => {
    this.editable = value;
  }

  handleCreateNewWithEncounter = (encounter) => {
    if (encounter) {
      const searchDto = {
        patientId: encounter?.patient?.id,
        encounterId: encounter.id,
        idPeriodTransferByManagementUnit: encounter?.idPeriodTransferByManagementUnit,
        idPeriodTransfer: encounter?.idPeriodTransfer,
      }
      createdCheckPeriod(searchDto).then(({data}) => {
        runInAction(() => {
          this.selectedTreatmentBookDetail = {
            ...data,
            patientType: encounter?.patientType,
            encounterId: encounter.id,
            regimen: encounter?.regimen,
            isTransferToFromTreatment: encounter?.isTransferToFromTreatment ? true : false,
            idPeriodTransfer: encounter?.idPeriodTransfer,
            //loại kháng thuốc
            typeResistance: encounter?.typeResistance,
            //phân loại theo tiền sử điều trị
            registerType: encounter?.registerType,
            otherRegisterType: encounter?.otherRegisterType,
            //quyền sửa
            edit: true,
            //hiv trước điều trị lao
            activeTbHiv: [
              {
                adviseTestHIV: encounter?.orderTest?.testHiv,
                art: encounter?.orderTest?.hiv?.art ? LocalConstants?.ART?.[1]?.value : null,
                startDateARV: encounter?.orderTest?.hiv?.startDateARV,
                cpt: encounter?.orderTest?.hiv?.cpt ? LocalConstants?.CPT?.[1]?.value : null,
                registerClinicOutpatientHIV: encounter?.orderTest?.hiv?.registerHIVOrg
              },
            ]
          };
        })
      }).catch((error) => {
        console.log(error);
        toast.warning(i18n.t("toast.error"));
      })
    } else {
      const searchDto = {
        patientId: this.patientId,
      }
      createdCheckPeriod(searchDto).then(({data}) => {
        runInAction(() => {
          this.selectedTreatmentBookDetail = {
            ...data,
            //quyền sửa
            edit: true,
          };
        })
      }).catch((error) => {
        console.log(error);
        toast.warning(i18n.t("toast.error"));
      })
    }

    this.setEditable(true)
  }

  handleConfimDeleteEpisodeOfCare = async (id) => {
    await deleteEpisodeOfCare(id).then(() => {
      toast.success(i18n.t("toast.delete_success"));
    }).catch(() => {
      toast.warning(i18n.t("toast.delete_fail"));
    })
  }

  resetTreatmentBook = () => {
    this.handleSelectItem(null);
  }

  saveADSMPatient = async (obj) => {
    try {
      return await saveADSMPatient(obj);
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.update_fail"));
    }
  }

  setOpenPrintPreview = (state) => {
    this.openPrintPreview = state
  }

  handlePrintPeriod = () => {
    this.setOpenPrintPreview(true)
  }
}
